import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Loader2, FileText, AlertCircle } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";

export default function FileRedirect() {
    const { id } = useParams();
    const { user } = useAuth();
    const navigate = useNavigate();
    const [status, setStatus] = useState("loading"); // loading | error
    const [errMsg, setErrMsg] = useState("");

    useEffect(() => {
        // user: null=loading, false=anon, object=auth
        if (user === null) return; // ancora in caricamento
        if (!user) {
            // Non autenticato → vai a login con redirect path
            navigate(`/login?next=${encodeURIComponent(`/file/${id}`)}`, { replace: true });
            return;
        }
        // Scarica il file e apri il blob in una nuova tab
        let cancelled = false;
        api.get(`/files/${id}`, { responseType: "blob" })
            .then((resp) => {
                if (cancelled) return;
                const blob = resp.data;
                const objectUrl = URL.createObjectURL(blob);
                // Apri direttamente la pagina corrente sul file (così l'utente vede il PDF o il download parte)
                window.location.replace(objectUrl);
                // Cleanup dopo 60s
                setTimeout(() => URL.revokeObjectURL(objectUrl), 60_000);
            })
            .catch((e) => {
                if (cancelled) return;
                setStatus("error");
                setErrMsg(e.response?.status === 404
                    ? "File non trovato o rimosso."
                    : e.response?.status === 403
                        ? "Non hai accesso a questo file."
                        : "Errore di caricamento del file.");
            });
        return () => { cancelled = true; };
    }, [id, user, navigate]);

    if (status === "error") {
        return (
            <div className="min-h-screen flex items-center justify-center p-6 bg-gray-50">
                <div className="bg-white rounded-2xl border border-gray-200 p-8 max-w-md text-center"
                     data-testid="file-redirect-error">
                    <div className="w-14 h-14 rounded-full bg-rose-50 flex items-center justify-center mx-auto mb-3">
                        <AlertCircle className="w-7 h-7 text-rose-600" />
                    </div>
                    <h2 className="text-xl font-black text-[#0C4650]">File non disponibile</h2>
                    <p className="text-gray-600 mt-2">{errMsg}</p>
                    <button
                        onClick={() => navigate("/dashboard")}
                        className="btn-primary mt-5"
                    >
                        Torna alla dashboard
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen flex items-center justify-center p-6 bg-gray-50">
            <div className="bg-white rounded-2xl border border-gray-200 p-8 max-w-md text-center"
                 data-testid="file-redirect-loading">
                <div className="w-14 h-14 rounded-full bg-[#C7FF2C]/30 flex items-center justify-center mx-auto mb-3">
                    <FileText className="w-7 h-7 text-[#0C4650]" />
                </div>
                <h2 className="text-xl font-black text-[#0C4650]">Apertura allegato…</h2>
                <p className="text-gray-600 mt-2">
                    Stiamo preparando il file per te
                </p>
                <Loader2 className="w-6 h-6 animate-spin text-[#0C4650] mx-auto mt-4" />
            </div>
        </div>
    );
}
